export class WebOrderItemModel
{
    public productId: number;
    public quantity: number;
    public totalAmount: number;
    public data: string;
    public productType?: string;
    public attributes?: string;
    public itemDetail: Array<WebOrderItemDetailModel>;  
}

export class WebOrderItemDetailModel
{
    public itemId : string;
    public categoryName: string;
    public categoryType: string
    public items: Array<CartItemModel>;  
   
}

export class CartItemModel
{
    public productId: number;
    public productName: string;
    public quantity: number;
    public includedQuantity: number;
    public value: number;
    public attributes :string;
    public productType: string;
}